import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Enroll from "../pages/enroll/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/enroll",
    element: <Enroll />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
